import { Component, Input } from '@angular/core';
import { RootScopeService } from '../../../services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent {

  iconConfig: any;
  alertConfig: any;
  @Input()
  isWarningToHide: boolean = true;

  @Input()
  isErrorToHide: boolean = true;

  @Input()
  isInfoToHide: boolean = true;

  @Input()
  isSuccessToHide: boolean = true;


  @Input()
  msg: any;
  public networkMsg=Constants.ALIS_CONNECTION_FAILURE_MSG;//CCR3-13543

  constructor(public rootScope: RootScopeService,public genesysService :GenesysCloudService) {

    this.iconConfig = {
      iconName: 'bullhorn',
      iconType: 'light'
    }

    this.alertConfig = {
      type: 'error'
    }
  }



  closeWarning() {
    // console.log("Method closeWarning called ")
    this.rootScope.isWarningToHide = !this.rootScope.isWarningToHide;
  }

 
  /**
   * Reloads the current page after performing necessary cleanup actions.
   * @author  VamsiKrishna  CCR3-13543
   * This method performs the following steps:
   * 1. Closes all Keycloak windows, external tabs, and ALS tabs via the rootScope service.
   * 2. Sets a flag in sessionStorage to indicate that a reload has been attempted.
   * 3. Waits for 50 milliseconds before reloading the browser window.
   *
   * Intended to ensure a clean application state before reloading.
   */
  /* istanbul ignore next */
  reload(){
    sessionStorage.setItem('reloadAttempted', 'true');

    this.genesysService.openUrlInIframe(window.location.href+'genesys-login');//CCR3-13543
    // this.rootScope.closeAllKcWindow();
    // this.rootScope.closeAllExternalTabs();
    // this.rootScope.closeALSTab();
    
   
    // setTimeout(() => {
    //    window.location.reload();
    // }, 50);
   
  }

}
